/* =============================================================
   AVM Herbals — UI micro-interactions (vanilla, deferred)
   - Scroll-reveal for .avm-reveal elements (IntersectionObserver)
   - Sticky-header shadow toggle on scroll
   Respects prefers-reduced-motion.
   Load deferred:  <script src="{{ 'avm-ui.js' | asset_url }}" defer></script>
   ============================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Scroll reveal
  var revealEls = document.querySelectorAll('.avm-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // 2. Sticky-header shadow
  var header = document.querySelector('.section-header, .header-wrapper, header.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('avm-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  // 3. PDP gallery thumbnail switcher
  document.querySelectorAll('.avm-pdp-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = thumb.getAttribute('data-gallery-index');
      var gallery = thumb.closest('.avm-pdp-gallery');
      gallery.querySelectorAll('.avm-pdp-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      gallery.querySelectorAll('.avm-pdp-gallery__slide').forEach(function (s) { s.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var slide = gallery.querySelector('[data-gallery-slide="' + idx + '"]');
      if (slide) slide.classList.add('is-active');
    });
  });

  // 4. Sticky ATC — shows after native ATC scrolls out of view
  var stickyBar = document.getElementById('avm-sticky-atc');
  var nativeAtc = document.querySelector('.product-form__submit, [name="add"]');
  if (stickyBar && nativeAtc && 'IntersectionObserver' in window) {
    var stickyIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    stickyIO.observe(nativeAtc);
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { nativeAtc.click(); });
  }

  // 5. PDP tabs
  document.querySelectorAll('.avm-tabs').forEach(function (tabGroup) {
    tabGroup.querySelectorAll('.avm-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panels = tabGroup.nextElementSibling;
        if (!panels) return;
        var panelId = tab.getAttribute('data-tab');
        tabGroup.querySelectorAll('.avm-tab').forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        panels.querySelectorAll('.avm-tab-panel').forEach(function (p) { p.classList.remove('is-active'); p.hidden = true; });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var target = panels.querySelector('[data-panel="' + panelId + '"]');
        if (target) { target.classList.add('is-active'); target.hidden = false; }
      });
    });
  });
})();